import { cva } from 'class-variance-authority';

export const chipVariants = cva(
  'bg-color-background-base focus:border-color-text-dark inline-flex cursor-default flex-row items-center justify-center rounded-[32px] border px-0.5 transition-colors duration-300 focus:border-2',
  {
    variants: {
      color: {
        error: 'text-color-error-dark border-color-error-dark bg-color-background-base',
        info: 'text-color-info-dark border-color-info-dark bg-color-background-base',
        primary: 'text-color-primary-dark border-color-primary-dark bg-color-background-base',
        secondary: 'text-color-secondary-dark border-color-secondary-dark bg-color-background-base',
        success: 'text-color-success-dark border-color-success-dark bg-color-background-base',
        warning: 'text-color-warning-dark border-color-warning-dark bg-color-background-base',
      },
      size: {
        small: 'text-size-body3 h-2',
        medium: 'text-size-body2 h-4',
      },
      variant: {
        filled: '',
        outlined: '',
      },
      disabled: {
        true: 'opacity-35',
        false: '',
      },
      clickable: {
        true: 'cursor-pointer active:shadow-sm',
        false: '',
      },
    },
    compoundVariants: [
      {
        color: 'error',
        variant: 'filled',
        class: 'text-color-error-contrasttext border-color-error-dark bg-color-error',
      },
      {
        color: 'info',
        variant: 'filled',
        class: 'text-color-info-contrasttext border-color-info-dark bg-color-info',
      },
      {
        color: 'primary',
        variant: 'filled',
        class: 'text-color-primary-contrasttext border-color-primary-dark bg-color-primary',
      },
      {
        color: 'secondary',
        variant: 'filled',
        class: 'text-color-secondary-contrasttext border-color-secondary-dark bg-color-secondary',
      },
      {
        color: 'success',
        variant: 'filled',
        class: 'text-color-success-contrasttext border-color-success-dark bg-color-success',
      },
    ],
  },
);
